import api from '@services/api';
import { DisableInput, DisregardEventRequest, DisregardEventResponse } from '../models/disregardEvents';
import { PaginationResponse } from '../models/pagination';

/**
 * API endpoints for managing Disregard Events in the indirect expense sharing process.
 *
 * This includes:
 * - Listing all disregard events with pagination, search, and filter for excluded events.
 * - Considering all disregard events (reverting exclusions to include in sharing).
 * - Excluding all events from the sharing process.
 */
export const disregardEventsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    ListAllEvents: builder.query<PaginationResponse<DisregardEventResponse>, DisregardEventRequest>({
      query: (parans: DisregardEventRequest) => {
        return {
          url: encodeURI(
            `/indirect/expense/search?searchTerm=${parans.searchTerm}&bringExcluded=${parans.bringExcluded}&page=${parans.page}&size=${parans.size}&sortKey=name&sortDirection=ASC`,
          ),
          method: 'GET',
        };
      },
      providesTags: ['ListAllEvents'],
    }),
    considerAll: builder.mutation<void, DisableInput>({
      query: (input) => ({
        url: '/indirect/expense/considerAll',
        method: 'PUT',
        body: input,
      }),
      invalidatesTags: ['ListAllEvents'],
    }),
    DiseblaAllEvents: builder.mutation<void, DisableInput>({
      query: (input) => ({
        url: `/indirect/expense/excludeAll`,
        method: 'PUT',
        body: input,
      }),
      invalidatesTags: ['ListAllEvents'],
    }),
  }),
});

export const { useListAllEventsQuery, useConsiderAllMutation, useDiseblaAllEventsMutation } = disregardEventsApi;
